// src/components/HomeBody.js
import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; 
import { COLORS } from '../theme';
import { formatDateToIso, getDayOfWeek } from '../utils';
import UpcomingEvents from '../UpcomingEvents';
import EventCard from './EventCard'; 
import SponsorSpot from './SponsorSpot';
import { db } from '../firebase';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

const HomeBody = ({ 
    selectedDate, setSelectedDate, onSelectDateWrapper, getTileContent, 
    events, displayEvents, isLoading, appConfig, lineUser, userInfo,
    openChatId, setOpenChatId, chatInput, setChatInput,
    activeChatMessages, // ★追加: サブコレクションのチャットデータを受け取る
    setActiveTab, 
    handlers
}) => {
    const selectedIsoDate = formatDateToIso(selectedDate);
    const [latestNews, setLatestNews] = useState(null);

    useEffect(() => {
        const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'));
        
        const unsub = onSnapshot(q, (snap) => {
            const activeDoc = snap.docs.find(doc => doc.data().isActive === true);
            if (activeDoc) {
                setLatestNews({ id: activeDoc.id, ...activeDoc.data() });
            } else {
                setLatestNews(null);
            }
        }, (error) => {
            console.error("お知らせ取得エラー:", error);
        });
        return () => unsub();
    }, []);

    return (
        <>
            {latestNews && (
                <div 
                    onClick={() => setActiveTab('news')} 
                    style={{
                        background: 'linear-gradient(90deg, #ff9800, #ffb74d)',
                        color: 'white',
                        padding: '12px 15px',
                        borderRadius: '8px',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        boxShadow: '0 2px 5px rgba(255, 152, 0, 0.3)'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden' }}>
                        <span style={{ fontSize: '16px' }}>📢</span>
                        <span style={{ 
                            fontSize: '13px', 
                            fontWeight: 'bold', 
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis' 
                        }}>
                            {latestNews.title}
                        </span>
                    </div>
                    <span style={{ fontSize: '12px', fontWeight: 'bold', flexShrink: 0 }}>詳細 ＞</span>
                </div>
            )}

            <Calendar onChange={(date) => { setSelectedDate(date); }} value={selectedDate} tileContent={getTileContent} locale="ja-JP" prev2Label={null} next2Label={null} />
            <UpcomingEvents events={events.filter(e => e.isoDate >= formatDateToIso(new Date()))} onSelectDate={onSelectDateWrapper} />

            <div className="status-bar" style={{marginTop:'30px', borderBottom:'none'}}>
                <h3 style={{ margin: 0, color: '#444', borderLeft:`4px solid ${COLORS.primary}`, paddingLeft:'10px' }}>
                      {selectedDate.getMonth() + 1}月{selectedDate.getDate()}日 ({getDayOfWeek(selectedIsoDate)})
                </h3>
            </div>
            
            {isLoading ? <div style={{textAlign:'center', color:'#999'}}>読み込み中...</div> : 
                displayEvents.length > 0 ? (
                    displayEvents.map((event) => (
                        <EventCard 
                            key={event.id}
                            event={event} 
                            lineUser={lineUser}
                            userInfo={userInfo}
                            appConfig={appConfig}
                            onEventAction={handlers.handleEventAction}
                            onCheckIn={handlers.handleCheckIn}
                            onCancelCheckIn={handlers.handleCancelSelfCheckIn}
                            onPayPay={handlers.handlePayPayAction}
                            onPointPayment={handlers.handlePointPayment}
                            onCashPayment={handlers.handleCashPayment}
                            onShare={handlers.handleShareResult}
                            onChatPost={handlers.handlePostChat}
                            onChatDelete={handlers.handleDeleteChat}
                            openChatId={openChatId}
                            setOpenChatId={setOpenChatId}
                            chatInput={chatInput}
                            setChatInput={setChatInput}
                            activeChatMessages={activeChatMessages} // ★追加: EventCardへ渡す
                            onMemberClick={handlers.handleMemberClick} 
                        />
                    ))
                ) : (
                <div className="card" style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                    <div style={{fontSize:'40px', marginBottom:'10px'}}>📅</div>
                    <p style={{margin:0}}>予定はありません</p>
                </div>
            )}

            {/* ★スポンサー枠（ランダム1件）。イベント一覧の直後に1つだけ置く。
                EventCard の中に入れると1日5件のときに5つ並んでしまうため、
                一覧全体の下にまとめている。掲載が無ければ何も表示されない。 */}
            <SponsorSpot variant="text" setActiveTab={setActiveTab} style={{ marginTop: '20px' }} />

            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'8px', padding:'0 5px', marginTop:'30px', marginBottom:'20px'}}>
                <button onClick={()=>setActiveTab('shop')} className="card" style={{margin:0, padding:'15px', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', background:'linear-gradient(135deg, #fff, #f5f5f5)', border:'1px solid #ddd', cursor:'pointer'}}>
                    <div style={{fontSize:'24px', marginBottom:'5px'}}>🛒</div>
                    <div style={{fontWeight:'bold', color:'#333', fontSize:'14px'}}>ショップ</div>
                    <div style={{fontSize:'10px', color:'#999'}}>アイテム購入</div>
                </button>
                <button onClick={()=>setActiveTab('shrine')} className="card" style={{margin:0, padding:'15px', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', background:'linear-gradient(135deg, #fff8e1, #ffecb3)', border:'1px solid #ffe0b2', cursor:'pointer'}}>
                    <div style={{fontSize:'24px', marginBottom:'5px'}}>⛩️</div>
                    <div style={{fontWeight:'bold', color:'#e65100', fontSize:'14px', width:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                        {appConfig.shrineName && appConfig.shrineName.startsWith('http') ? (
                            <img src={appConfig.shrineName} alt="神社" style={{height:'20px', maxWidth:'100px', objectFit:'contain'}} />
                        ) : (
                            appConfig.shrineName || 'RB大社'
                        )}
                    </div>
                    <div style={{fontSize:'10px', color:'#e65100'}}>祈願・厄除・初詣対応</div>
                </button>
                <button onClick={()=>setActiveTab('sponsors')} className="card" style={{margin:0, padding:'15px', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', background:'linear-gradient(135deg, #fff3e0, #ffe0b2)', border:'1px solid #ffcc80', cursor:'pointer'}}>
                    <div style={{fontSize:'24px', marginBottom:'5px'}}>🎫</div>
                    <div style={{fontWeight:'bold', color:'#e65100', fontSize:'14px'}}>特典</div>
                    <div style={{fontSize:'10px', color:'#ef6c00'}}>提携店クーポン</div>
                </button>
            </div>
            
            <div style={{ marginTop: '15px' }}>
                <button 
                    onClick={() => setActiveTab('gacha')} 
                    style={{ 
                        width: '100%', 
                        background: 'linear-gradient(135deg, #ffd700, #ff8c00)',
                        color: '#333', 
                        border: '2px solid #e65100', 
                        padding: '15px', 
                        borderRadius: '12px', 
                        fontWeight: '900', 
                        fontSize: '18px', 
                        cursor: 'pointer', 
                        boxShadow: '0 4px 12px rgba(255, 140, 0, 0.3)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '12px',
                        letterSpacing: '1px',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <span style={{ fontSize: '24px' }}>⚽️</span>
                    <span>メンバーカードガチャ</span>
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)', transform: 'skewX(-20deg) translateX(-150%)', animation: 'shine 4s infinite' }}></div>
                </button>
            </div>

            <div style={{ marginTop: '10px', marginBottom: '20px' }}>
                <button 
                    onClick={() => setActiveTab('arena')} 
                    style={{ 
                        width: '100%', 
                        background: 'linear-gradient(135deg, #b71c1c, #d32f2f)', 
                        color: 'white', 
                        border: 'none', 
                        padding: '20px', 
                        borderRadius: '12px', 
                        fontWeight: '900', 
                        fontSize: '18px', 
                        cursor: 'pointer', 
                        boxShadow: '0 6px 15px rgba(211, 47, 47, 0.4)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '12px',
                        letterSpacing: '2px',
                        position: 'relative',
                        overflow: 'hidden'
                    }}
                >
                    <span style={{ fontSize: '28px', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>🏟️</span>
                    <span style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>アリーナで対戦する</span>
                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)', transform: 'skewX(-20deg) translateX(-150%)', animation: 'shine 3s infinite' }}></div>
                </button>
            </div>
           
            <div style={{height:'180px'}}></div>
        </>
    );
};

export default HomeBody;